import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "首页", path: "/" },
  { label: "AI美女写真", path: "/category/ai-meinv-xiezhen" },
  { label: "AI美女头像", path: "/category/ai-meinv-touxiang" },
  { label: "AI美女壁纸", path: "/category/ai-meinv-bizhi" },
  { label: "AI虚拟美女", path: "/category/ai-xuni-meinv" },
  { label: "教程资讯", path: "/article/ai-meinv-shengcheng-rumen" },
  { label: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className="text-xl font-heading font-semibold text-foreground-950">
              AI美学生成
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 text-sm rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? "text-primary-600 font-medium"
                    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="ml-2 px-5 py-2 text-sm bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer font-medium"
            >
              开始创作
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer text-foreground-700 hover:text-foreground-950"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl`}></i>
          </button>
        </div>
      </div>

      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          mobileOpen ? "max-h-screen" : "max-h-0"
        }`}
      >
        <div className="bg-background-50 border-t border-background-200/70 px-4 py-3 space-y-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`block px-3 py-2.5 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? "text-primary-600 bg-primary-50 font-medium"
                  : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/about"
            className="block text-center mt-3 px-5 py-2.5 text-sm bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer font-medium"
          >
            开始创作
          </Link>
        </div>
      </div>
    </nav>
  );
}